


















































import Vue from 'vue'
import mixin from '../../../../components/FileTable/mixin.vue'
import FileDetail from './FileDetail.vue'
import ResourcePanel from './ResourcePanel.vue'
import FileList from './FileList.vue'
import {
  TransferDirectoryFileQueryServiceProxy,
  TransferDirectoryFileServiceProxy,
  ResourceServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'

const transferDirectoryFileQueryServiceProxy = new TransferDirectoryFileQueryServiceProxy()
const transferDirectoryFileServiceProxy = new TransferDirectoryFileServiceProxy()
const resourceServiceProxy = new ResourceServiceProxy()

export default Vue.extend({
  name: 'CurrentFileTab',
  components: { FileDetail, ResourcePanel, FileList },
  mixins: [mixin],
  props: {
    selectDirectory: {
      type: Object,
      default: () => ({})
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableLoading: false,
      fileList: [],
      tableGroup: [
        {
          title: 'page_my_document_program',
          dataSource: []
        },
        {
          title: 'page_my_document_process',
          dataSource: []
        }
      ],
      showResourcePanel: false,
      resourceParams: { resourceId: '', versionId: '' }, // 资源参数resourceId，versionId
      resource: {}
    }
  },
  watch: {
    fileList: {
      handler(val) {
        // fileType: 1: 加工文件, 2: 工艺文件
        this.tableGroup.map((item, i) => {
          item.dataSource = val ? val.filter(ite => ite.fileType === i + 1) : []
        })
      },
      deep: true,
      immediate: true
    },
    selectDirectory: {
      handler(val) {
        this.getFileList()
      },
      immediate: true
    }
  },
  methods: {
    // 获取工位文件下的文件列表
    getFileList() {
      this.tableLoading = true
      // 收起文件详情抽屉，并清空展示的文件详情
      this.showFileInfo = false
      this.fileInfo = {}
      this.resource = {}
      this.fileList = []
      if (!this.selectDirectory.id) {
        this.tableLoading = false
        return
      }
      transferDirectoryFileQueryServiceProxy.fileList('',this.selectDirectory.id).then((res: any) => {
        // console.log('文件列表：', res)
        this.fileList = res && res.length ? this.filterResources(res) : []
        this.tableLoading = false
      })
    },
    handleDelete(data: any) {
      transferDirectoryFileServiceProxy.delete(data.id).then((res: any) => {
        this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
        this.getFileList()
        this.$emit('updateLog') // 更新操作日志
      })
    },
    // 根据文件来源过滤文件，资源文件和回传文件不在文件列表下的表格显示
    // fileSource 文件来源  1：非资源   2：资源   4: 回传文件
    filterResources(res: any) {
      // 资源文件
      let temp = res.find((item: any) => item.fileSource === 2 && item.resourceId && item.versionId)
      this.resourceParams.resourceId = temp ? temp.resourceId : ''
      this.resourceParams.versionId = temp ? temp.versionId : ''
      this.getResource()
      // 回传文件
      let turnAroundDoc = res.filter((item: any) => item.fileSource === 4)
      this.$emit('splitFile', turnAroundDoc)
      // 非资源
      let list = res.filter((item: any) => item.fileSource === 1 || item.versionId === null)
      return list
    },
    // 获取资源包信息
    getResource() {
      if (this.resourceParams.resourceId && this.resourceParams.versionId) {
        resourceServiceProxy.resourceVersionDetail(this.resourceParams.resourceId, this.resourceParams.versionId).then((res: any) => {
          this.resource = res
        })
      }
    },
    // 显示资源包详情面板
    showResourcePackage() {
      this.showResourcePanel = true
    },
    // 关闭资源包面板
    closeResourcePackage() {
      this.showResourcePanel = false
    },
    // 删除资源包，即取消资源包与工位文件的关联
    deleteResource() {
      this.$confirm({
        title: this.$t('page_transport_directory_delete_resource_confirm') + `?`,
        content: this.$t('page_transport_directory_delete_resource_confirm_content'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          return new Promise((resolve, reject) => {
            transferDirectoryFileServiceProxy.deleteFileByResourceId(this.resourceParams.resourceId).then((res) => {
              resolve()
              this.clearResource()
              this.$emit('updateLog')
            })
          })
        }
      })
    },
    clearResource() {
      this.resource = {}
    },
  }
})
